import React, { useState, useEffect } from 'react';
import { Link, Redirect } from 'react-router-dom';
import userStore from '../../../Stores/User';
import { observer } from 'mobx-react';
import Play from '../../DiscoverNew/Icons/Play.svg';
import Pause from '../../DiscoverNew/Icons/Pause.svg';
import { loadStripe } from '@stripe/stripe-js';
import mixpanel from 'mixpanel-browser';
import loadingIcon from '../../../Assets/loading.gif';
import { createSubscriptionCheckoutSessionWithTrial } from '../../../audiblogsApi';
import queryString from 'query-string';
import YoutubeIframe from "../../Landing/Components/YoutubeIframe.tsx";

const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY;
const stripePromise = loadStripe(STRIPE_API_KEY);

function ChooseVoice(props) {
  const [quality, setQuality] = useState('Unreal');
  const [sessionId, setSessionId] = useState(null);
  const params = queryString.parse(props.location.search);
  const app = params.app || '';

  // const redirectToCheckout = () => {
  //   stripePromise.then((stripe) => {
  //     stripe
  //       .redirectToCheckout({
  //         sessionId,
  //       })
  //       .then((handleResult) => {
  //         console.log('handle results');
  //         handleResult();
  //       })
  //       .catch((e) => {
  //         console.log(e);
  //       });
  //   });
  // };

  // useEffect(() => {
  //   const idToken = userStore.idToken;
  //   if (idToken) {
  //     // Get Stripe Checkout Session Id
  //     createSubscriptionCheckoutSessionWithTrial(
  //       true,
  //       idToken,
  //       `/onboarding/howtoclip${app === "chrome" && '?app=chrome'}`,
  //       quality
  //     )
  //       .then(function (data) {
  //         setSessionId(data.data.sessionId);
  //       })
  //       .catch((e) => {
  //         console.log(e);
  //         alert('Something went wrong. Please try again or contact us.');
  //       });
  //   }
  // }, [userStore.idToken]);

  // useEffect(() => {
  //   const idToken = userStore.idToken;
  //   if (userStore.user.trial_sd || userStore.user.trial_hd) {
  //   }
  // }, [userStore.user]);

  return (
    <div className="center-static">
      <h1 className="headline" style={{ marginBottom: '0px' }}>
      🎉 You're in! 
      </h1>

      <div>
        <div className="subheadline" style={{ marginTop: '15px' }}>
          Let's add your first feed! 
        </div>
        {/* <div>
          Video Goes Here
        </div> */}
        {/* <YoutubeIframe videoId={"MVcS_jpdJPk"} videoTitle={"Audioread Walkthrough"} /> */}

      </div>
      <div
        className="cta-div"
        style={{ position: 'static', marginTop: '24px' }}
      >
        <button className="cta-button">
          <Link

            to={`/onboarding/quickstart/1`}
            style={{ textDecoration: 'none' }}
          >
            <div>Browse Popular Feeds →</div>
          </Link>
        </button>
      </div>

    </div>
  );
}

export default ChooseVoice;
